import { vimeoPattern } from '@shared/utils/constants/patterns'

export const isVimeoLink = (link?: string): boolean => {
  return !!(link ?? '').match(vimeoPattern)
}

export const convertToVimeoEmbed = (link?: string): string | undefined => {
  if (!link || !isVimeoLink(link)) {
    return link
  }

  // Extract video ID from Vimeo URL
  const match = link.match(/(?:https?:\/\/)?(?:www\.)?(?:vimeo\.com\/)([0-9]+)/)
  const videoId = match ? match[1] : null

  if (!videoId) {
    return link
  }

  return `https://player.vimeo.com/video/${videoId}`
}
